
import { TimeIntervalEnum } from "../enums/timeIntervalEnum";

import * as appsettings     from "../appsettings";
import * as main            from "../main";
import * as moment          from "moment";
import * as timeinterval    from "../timeinterval";

/*
* Show / Hide Period Selector
**/
function setVisibilityPeriodSelector(): void {
    const timeinterval_value = parseInt($("#TimeInterval").data("kendoDropDownList").value());

    if (timeinterval_value == TimeIntervalEnum.AskedPeriod) {
        $("#periodSelector").show();
    } else {
        $("#periodSelector").hide();
    }
}

function enableTimeIntervalControls(): void {
    $("#TimeInterval").data("kendoDropDownList").enable(true);
    $("#TimeInterval").siblings('.k-input-button').removeAttr("disabled");
    $("#From").data("kendoDateTimePicker").enable(true);
    $("#From").siblings('.k-input-button').removeAttr("disabled");
    $("#To").data("kendoDateTimePicker").enable(true);
    $("#To").siblings('.k-input-button').removeAttr("disabled");
    $("#PagerDiagnosticsShowButton").removeAttr("disabled");
}


/**
* Initialize
*/
export function initialize(showHistory: boolean): void {
    $("#PagerDiagnosticsShowButtonLoader").hide();

    if (showHistory) {
        setVisibilityPeriodSelector();
        enableTimeIntervalControls();
        this.showAction(null);
    } else {
        main.setHideDiv("divHardware", false);
        main.setHideDiv("divHistory", false);
    }
}

/**
* onChange for TimeInterval (show / hide periodSelector)
*/
export function onChangeTimeInterval(): void {
    setVisibilityPeriodSelector();
}

/**
* Action show (will display battery and signal line charts according to the selected period)
*/
export function showAction(): void {
    // Indicator
    $("#PagerDiagnosticsShowButtonLoader").show();

    // get preference / options selected
    const pagerId = Number($("#PagerID").val());
    const selectedInterval = Number($("#TimeInterval").data("kendoDropDownList").value());

    // Get selection period
    const From = moment(timeinterval.getBeginPeriodSelection(selectedInterval, "From").toUTCString()).format("YYYY-MM-DD[T]HH:mm:ss");
    const To = moment(timeinterval.getEndPeriodSelection(selectedInterval, "To").toUTCString()).format("YYYY-MM-DD[T]HH:mm:ss");

    // Do request
    $.ajax({
        type: "GET",
        url: appsettings.getUrl("User/ShowPagerDiagnosticsCharts"),
        data: {
            PagerID: pagerId,
            From: From,
            To: To
        },
        success: function (responseData) {
            // Get response
            $("#showResult").html(responseData);

            // Hide Indicator
            $("#PagerDiagnosticsShowButtonLoader").hide();
        }
    });
}

/**
* start / from 
*/
export function fromChange(): void {
    const start = $("#From").data("kendoDateTimePicker");
    const end = $("#To").data("kendoDateTimePicker");
    let startDate = start.value();
    let endDate = end.value();

    if (startDate) {
        startDate = new Date(startDate);
        startDate.setDate(startDate.getDate());
        end.min(startDate);
    } else if (endDate) {
        start.max(new Date(endDate));
    } else {
        endDate = new Date();
        start.max(endDate);
        end.min(endDate);
    }
}

/**
* end / to
*/
export function toChange(): void {
    const start = $("#From").data("kendoDateTimePicker");
    const end = $("#To").data("kendoDateTimePicker");
    let endDate = end.value();
    let startDate = start.value();

    if (endDate) {
        endDate = new Date(endDate);
        endDate.setDate(endDate.getDate());
        start.max(endDate);
    } else if (startDate) {
        end.min(new Date(startDate));
    } else {
        endDate = new Date();
        start.max(endDate);
        end.min(endDate);
    }
}
